import React, { useEffect, useState } from "react";
import FormModal from "../../Modals/FormModal";
import SelectField from "../../Forms/Input/SelectField";
import FileUploader from "../../Uploader/FileUploader";
import clsx from "clsx";
import { QzTrayCertificateType } from "../../../types/qztray/QzTrayCertificateTypes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (file: File, type: QzTrayCertificateType) => void;
  isSubmitting: boolean;
}

const QzTrayCertificateUploadModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  isSubmitting,
}) => {
  const [type, setType] = useState<QzTrayCertificateType | "">("");
  const [file, setFile] = useState<File | null>(null);

  useEffect(() => {
    if (isOpen) {
      setType("");
      setFile(null);
    }
  }, [isOpen]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!type || !file) return;
    onSubmit(file, type);
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Subir Certificado QZ Tray"
      maxWidth="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="mt-4 grid grid-cols-1 gap-6">
        
        {/* 🔹 Tipo de certificado */}
        <SelectField
          label="Tipo de Certificado"
          name="type"
          value={type}
          onChange={(e) => setType(e.target.value as QzTrayCertificateType)}
          options={[
            { label: "Clave Privada (.key)", value: "PRIVATE_KEY" },
            { label: "Certificado Público (.crt)", value: "CERTIFICATE" },
          ]}
          placeholder="Seleccione tipo de certificado"
          iconKey="key"
          required
        />

        {/* 🔹 Archivo */}
        <FileUploader
          currentFile={file}
          onFileChange={setFile}
          onRemoveFile={() => setFile(null)}
          label="Seleccione archivo"
          accept={
            type === "PRIVATE_KEY"
              ? ".key"
              : ".crt"
          }
          iconKey="upload"
        />

        {/* 🔹 Botón enviar */}
        <button
          type="submit"
          disabled={isSubmitting}
          className={clsx(
            "w-full rounded px-4.5 py-2.5 font-medium text-white",
            isSubmitting
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-primary hover:bg-opacity-90"
          )}
        >
          {isSubmitting ? "Subiendo..." : "Subir Certificado"}
        </button>
      </form>
    </FormModal>
  );
};

export default QzTrayCertificateUploadModal;
